@if (isLoading) {
	<div class="overlay-new"></div>
}
@if (isImporting) {
	<div class="overlay-new">
		<div class="import-progress-message">
			{{ 'mes.administration.printer.import.progress' | translate }}
		</div>
	</div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'mes.administration.printer.printers' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.users.search' | translate" #input [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems"></header-sub-menu>
	</div>
</div>

<div class="table-wrapper">
	<table mat-table recycleRows [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
		<ng-container matColumnDef="alias">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.printer.shared.name' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.alias }}</td>
		</ng-container>

		<ng-container matColumnDef="description">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.printer.shared.description' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.description }}</td>
		</ng-container>

		<ng-container matColumnDef="encoding">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.printer.shared.encoding' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.encoding }}</td>
		</ng-container>
		<ng-container matColumnDef="printerPath">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.printer.shared.printer-path' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.printerPath }}</td>
		</ng-container>
		<ng-container matColumnDef="tags">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.printer.shared.tags' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.tags }}</td>
		</ng-container>
		<ng-container matColumnDef="menu">
			<th mat-header-cell *matHeaderCellDef class="menu-column-header"></th>
			<td mat-cell *matCellDef="let row" class="menu-column-cell">
				<button mat-icon-button [matMenuTriggerFor]="menu">
					<mat-icon mat-list-icon svgIcon="acies_overflow_menu" class="menu-icon"></mat-icon>
				</button>
				<mat-menu #menu="matMenu">
					<button *appHasPermission="'print:PrinterPut'" mat-menu-item (click)="openEditPrinter(row.printer)">
						<span>{{ 'mes.administration.printer.shared.editbtn' | translate }}</span>
					</button>
					<button mat-menu-item (click)="openDeletePrinter(row.printer)">
						<span>{{ 'mes.administration.printer.shared.deletebtn' | translate }}</span>
					</button>
				</mat-menu>
			</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</div>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500]" [pageSize]="100" showFirstLastButtons></mat-paginator>
